<style scoped lang="less">
  .patient {
    border: 1px solid #E9E9E9;
    position: relative;
  }
  .info {
    font-size: 15px;
    color: #666666;
    display: flex;
    padding: 20px;
    box-sizing: border-box;
  }
  .details {
    flex: 1;
    padding: 0 20px;
  }
  .actions {
    background: #F7F7F7;
    display: flex;
    div {
      position: relative;
      cursor: pointer;
      flex: 1;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      color: rgba(0, 0, 0, 0.45);
      transition: all .3s;
      &:hover {
        color: #4170DE;
      }
    }
    div + div::before {
      content: '';
      height: 40%;
      background: #E8E8E8;
      width: 1px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .del {
    position: absolute;
    right: 10px;
    top: 10px;
    color: #B3B3B3;
    cursor: pointer;
  }
</style>

<template>
  <div class="patient">
    <div class="info">
      <div class="avatar">
        <div style="width: 46px; height: 46px; background: #3ABFA9;border-radius: 23px;"></div>
      </div>
      <div class="details">
        <div style="display: flex;justify-content: space-between;">
          <div><span style="font-weight: 800;">{{data.name}}</span></div>
          <div>性别: <span style="font-weight: 800;">{{data.sex}}</span></div>
          <div>年龄: <span style="font-weight: 800;">{{data.age}}</span></div>
        </div>
        <div style="margin-top: 13px;">
          <span style="color: #666;">联系方式: </span>
          <span style="color: #333;">{{data.phone}}</span>
        </div>
        <div style="margin-top: 13px;">
          <span style="color: #666;">身份证号: </span>
          <span style="color: #333;">{{data.idNo}}</span>
        </div>
      </div>
    </div>
    <div class="actions">
      <router-link tag="div" :to="{name: 'patients.details.prescription', query: {id: data.id}}">开处方</router-link>
      <router-link tag="div" :to="{name: 'patients.details.info', query: {id: data.id}}">查看明细</router-link>
    </div>
    <div class="del">
      <i class="iconfont icon-shanchu" @click="del"></i>
    </div>
  </div>
</template>

<script>
import { patientRequest } from '@/api'

export default {
  props: {
    data: { type: Object, default: null }
  },
  methods: {
    async del () {
      const r = await this.$dialog.confirm('确定要删除' + this.data.name + '么?')
      if (r) {
        await patientRequest.del(this.data.id)
        this.$notice.success('已删除')
        this.$emit('del', this.data)
        this.$el.remove()
        this.$destroy()
      }
    }
  }
}
</script>
